const defaultWordsPerLine = 3
const desktopSplitHeaderMediaQuery = '(min-width: 1024px)'

const htmlEscapes = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }
const escapeHtml = (value) => value.replace(/[&<>"']/g, (char) => htmlEscapes[char])

const applySplitHeaderState = (textContainer, wordsPerLine, shouldApply) => {
  const titleText =
    textContainer.dataset.splitHeaderOriginalText || textContainer.textContent?.trim()
  if (!titleText) return

  textContainer.dataset.splitHeaderOriginalText = titleText

  if (!shouldApply) {
    textContainer.textContent = titleText
    delete textContainer.dataset.splitHeaderApplied
    return
  }

  if (textContainer.dataset.splitHeaderApplied === 'true') return

  const words =
    Number.isInteger(wordsPerLine) && wordsPerLine > 0 ? wordsPerLine : defaultWordsPerLine

  const wordsArray = titleText.split(/\s+/)
  const numberOfLines = Math.ceil(wordsArray.length / words)
  const result = []

  for (let i = 0; i < numberOfLines; i++) {
    const spliced = wordsArray.splice(0, words)
    if (spliced.length) result.push(spliced.join(' '))
  }

  const mappedOutput = result
    .map((item) => {
      return `<span class='text-fragment'>${escapeHtml(item)}</span>`
    })
    .join('\n')

  textContainer.innerHTML = mappedOutput
  textContainer.dataset.splitHeaderApplied = 'true'
}

const SplitHeader = (elementOrSelector, wordsPerLine = defaultWordsPerLine) => {
  const textContainer =
    typeof elementOrSelector === 'string'
      ? document.querySelector(elementOrSelector)
      : elementOrSelector

  if (!textContainer) return

  const desktopMediaQuery = window.matchMedia(desktopSplitHeaderMediaQuery)
  const applySplitHeader = () => {
    applySplitHeaderState(textContainer, wordsPerLine, desktopMediaQuery.matches)
  }

  applySplitHeader()

  if (textContainer.dataset.splitHeaderBound === 'true') return

  if (typeof desktopMediaQuery.addEventListener === 'function') {
    desktopMediaQuery.addEventListener('change', applySplitHeader)
  } else {
    desktopMediaQuery.addListener(applySplitHeader)
  }

  textContainer.dataset.splitHeaderBound = 'true'
}

export default SplitHeader
